// extracted by mini-css-extract-plugin
export var aiStarSpin = "_mp-1";
export var spinner = "_mp-0";